import React, { useState } from 'react'
import Radio from '@material-ui/core/Radio'
import RadioGroup from '@material-ui/core/RadioGroup'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import FormControl from '@material-ui/core/FormControl'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  root: {
    '& .MuiTypography-body1': {
      color: '#142A39',
      fontSize: 16,
      fontWeight: 'bold',
    },
    '& .Mui-checked': {
      color: '#2D9F86',
    },
  },
  description: { marginLeft: '30px', textTransform: 'none', fontSize: '14px', fontFamily: 'Work Sans', fontWeight: 'normal' },
  group: { justifyContent: 'space-between', width: '1000px' }
}))

const RadioButtonAvailability = props => {
  const { input, label, options = {} } = props
  const classes = useStyles()
  return (
    <FormControl component="fieldset">
      <RadioGroup {...input} aria-label={input.name} row className={classes.group} name={input.name} value={input.value}>
        {options.map((item, index) =>
          <h1 key={index} style={index === 1 ? { marginTop: '0px' } : {}}>
            <FormControlLabel {...input} name={item.name} className={classes.root} value={item.id} control={<Radio />} label={item.name} />
            <p className={classes.description}>{item.description}</p>
          </h1>)}
      </RadioGroup>
    </FormControl>
  )
}

export default RadioButtonAvailability



// WEBPACK FOOTER //
// ./src/legacy/containers/Forms/components/RadioButtonAvailability/RadioButtonAvailability.jsx